module.exports = __webpack_public_path__ + "img/p2.f7081844.png";